import React, { useState } from 'react';
import { motion } from 'framer-motion';

const AuthPage = ({ onLogin, onRegister, onForgotPassword, error, clearError, shareInvitation, onBack }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isRegistering, setIsRegistering] = useState(false);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    if (error) clearError();
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    if (error) clearError();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isRegistering) {
      onRegister(email, password);
    } else {
      onLogin(email, password);
    }
  };

  return (
    <div className="auth-page-new">
      {onBack && (
        <button type="button" className="auth-back-button" onClick={onBack}>
          <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
      )}

      {shareInvitation && (
        <div className="share-invitation" style={{ marginBottom: '32px' }}>
          <div className="invitation-icon">🤝</div>
          <h2>You've been invited!</h2>
          <p className="invitation-message">
            <strong>{shareInvitation.sharedBy}</strong> shared{' '}
            <strong>"{shareInvitation.listName}"</strong> with you.
          </p>
          <p className="invitation-access">
            {shareInvitation.isPublic
              ? "This is a public list that anyone can access."
              : "You'll need an account to access this shared list."
            }
          </p>
        </div>
      )}

      <div className="auth-brand">
        <h1>Kanto.</h1>
        <p>Your household operating system.</p>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="auth-input-group">
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={handleEmailChange}
            placeholder="you@example.com"
          />
        </div>

        <div className="auth-input-group">
          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={handlePasswordChange}
            placeholder="••••••••"
          />
        </div>

        {error && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            className="error-message"
            style={{ marginTop: '16px' }}
          >
            {error}
          </motion.div>
        )}

        <button type="submit" className="auth-submit-button">
          {isRegistering
            ? (shareInvitation ? 'Create Account & Join' : 'Create Account')
            : (shareInvitation ? 'Log In & Join List' : 'Log In')
          }
        </button>
      </form>

      <div className="auth-footer">
        {isRegistering ? (
          <p>
            Already have an account?{' '}
            <button
              type="button"
              className="auth-link-button"
              onClick={() => setIsRegistering(false)}
            >
              Log in
            </button>
          </p>
        ) : (
          <>
            <p>
              Don't have an account?{' '}
              <button
                type="button"
                className="auth-link-button"
                onClick={() => setIsRegistering(true)}
              >
                Sign up
              </button>
            </p>
            <button
              type="button"
              className="auth-forgot-link"
              onClick={() => onForgotPassword(email)}
            >
              Forgot password?
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthPage;
